import { html } from 'lit';
import { LineChart } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-line-chart')
export class PdsIconLineChart extends PdsIcon {
  @state()
  icon = LineChart;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
